import { render, staticRenderFns } from "./login.vue?vue&type=template&id=667bf50f&scoped=true"
import script from "./login.js?vue&type=script&lang=js&external"
export * from "./login.js?vue&type=script&lang=js&external"
import style0 from "./login.scss?vue&type=style&index=0&id=667bf50f&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667bf50f",
  null
  
)

export default component.exports